import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { TextToAudioDemoPage } from '@/components/astro/new-design-25/SEO/text-to-audio-demo-page';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/_seo/text-to-speech')({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'Free Text to Speech Online — Natural AI Voices for Reading Aloud | Listening',
        description:
          'Convert text to speech online with natural AI voices in 8 languages. Free, no sign-up. Paste up to 10,000 characters and open a 24-hour read-along link with audio controls.',
      }),
    ],
    links: [...hreflangLinks('/text-to-speech')],
  }),
  component: () => (
    <TextToAudioDemoPage
      converterHeading='Text to speech'
      converterSubtitle='Paste your text and we will turn it into audio'
      conversionLabel='speech'
      faqDescription='Quick answers about converting text to speech with Listening.'
      faqTitle='Text to speech FAQ'
    />
  ),
});
